import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=d48de334&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=d48de334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48de334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle})
